import RotatingSpinner from '@components/Blackbird/RotatingSpinner/RotatingSpinner';
import { CheckCircle } from '@mui/icons-material';
import WarningIcon from '@mui/icons-material/Warning';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { useIngestionLogCounts } from '../hooks/useIngestionLogCounts.query';
import { useFetchIngestionLogs } from '../hooks/useIngestionLogSummary.query';
import { getValidLogs } from '../utilities/getValidLogs';
import { useIngestionDataSourceList } from '../hooks/useIngestionDataSourceList.query';

type TProps = { isMenuOpen: boolean };

function IngestionSummary({ isMenuOpen }: TProps) {
  // Counts gives us a general count of all ingestions run in the past 7 days.
  const { data: counts, isLoading: isLoadingCounts } = useIngestionLogCounts({ isMenuOpen });
  const { data: dataSourceList } = useIngestionDataSourceList();
  // From the logs, we get the current summary that should of the latest status of each ingestion for the last 7 days.
  const { data: logs } = useFetchIngestionLogs();
  const { currentSummary } = getValidLogs(logs, dataSourceList);

  if (isLoadingCounts || !counts) {
    return null;
  }

  return (
    <div
      data-theme="dark"
      className="tw:flex tw:flex-row tw:items-center tw:justify-center tw:p-3 tw:gap-2"
    >
      {counts.ingestionRunningCount > 0 && (
        <div className="tw:flex tw:flex-row tw:items-center tw:justify-center">
          <RotatingSpinner className="tw:mr-[4px]" style={{ fontSize: 16 }} />
          <span className="tw:text-xs">{counts.ingestionRunningCount}</span>
        </div>
      )}
      <div className="tw:flex tw:flex-row tw:items-center tw:justify-center">
        <CheckCircle className="tw:mr-[4px] tw:dark:text-status-ok-text" style={{ fontSize: 16 }} />
        <span className="tw:text-xs">{currentSummary.ingestionSuccessCount}</span>
      </div>
      <div className="tw:flex tw:flex-row tw:items-center tw:justify-center">
        <WarningIcon
          className="tw:mr-[4px] tw:dark:text-status-warning-text"
          style={{ fontSize: 16 }}
        />
        <span className="tw:text-xs">{currentSummary.ingestionWarningCount}</span>
      </div>
      <div className="tw:flex tw:flex-row tw:items-center tw:justify-center">
        <NewReleasesIcon
          className="tw:mr-[4px] tw:dark:text-status-alert-text"
          style={{ fontSize: 16 }}
        />
        <span className="tw:text-xs">{currentSummary.ingestionErrorCount}</span>
      </div>
    </div>
  );
}

export default IngestionSummary;
